import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../../components/layout/Header";
import Footer from "../../components/layout/Footer";

export default function DashboardLayout() {
  return (
    <div className="flex flex-column min-h-screen surface-ground">
      <Header />
      <div className="flex-grow-1 p-4 surface-0">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}
